/* eslint-disable max-lines-per-function */
import React from "react";
import { Grid } from "@mui/material";
import { Formik, Form } from "formik";
import { Modal } from "components/haven-design";
import { Button } from "components/haven-design/buttons";
import { InputWithErrorLabel } from "components/haven-design/form/inputs";
import {
  SelectAutocomplete,
} from "components/haven-design/form/select";
import styles from "../../actions.module.css";
import { Contact } from "./contact-picker";


export const ContactPickerOtherDialog:React.FC<{
  isOpen: boolean;
  onRequestClose: () => void;
  onSubmit: (values:Contact) => void;
}> = ({ isOpen, onRequestClose, onSubmit }) => {
  const initialValues:Contact = { name: "Other", otherType: null, email: null, mobile: null, type: "other" };

  return (
    <Modal
      style={{ width: 500, marginTop: 250 }}
      title="Other"
      isOpen={isOpen}
      onRequestClose={onRequestClose}>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          onSubmit(values);
        }}>
        {({ submitForm, isSubmitting, values, setFieldValue }) => (
          <Form>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12 }}>
                <SelectAutocomplete
                  label="Contact Type"
                  options={["Landlord", "Caretaker", "Employer"]}
                  value={values.otherType}
                  onChange={(_, value) => {
                    setFieldValue("otherType", value);
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <InputWithErrorLabel label="Email" name="email" />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <InputWithErrorLabel label="Mobile" name="mobile" />
              </Grid>
            </Grid>
            <div className={styles.confirmationFooter}>
              <Button
                className={styles.confirmationButton}
                color="secondary"
                size="S"
                onClick={onRequestClose}
                disabled={isSubmitting}
              >
            Cancel
              </Button>
              <Button
                className={styles.confirmationButton}
                color="primary"
                size="S"
                disabled={isSubmitting}
                onClick={submitForm}
              >
                {isSubmitting ? "Submitting" : "Confirm"}
              </Button>
            </div>
          </Form>)}
      </Formik>
    </Modal>
  );
};
